import React, { FunctionComponent } from 'react'
import { SankeyData, applicationDrawType, processFunctionsType } from 'open-sankey/src/types/Types'
import { SankeyDevData, SankeyDevShowMenuComponentsType } from 'sankeydev/types/Types'
import { suiteApplicationContextType, suiteApplicationDataType } from './Types'
import { ConvertDataFuncType } from 'open-sankey/src/configmenus/types/SankeyConvertTypes'
import { Modal_creation_view_unitary_from_data } from 'sankeydev/dist/src/SankeyDevUnitarySankey'
import { Modal_creation_view_unitary_from_dataType, devApplicationDataType } from 'sankeydev/types/SankeyDevUnitarySankeyTypes'

const SankeyDevModalCreationViewUnitaryFromData =
 Modal_creation_view_unitary_from_data as 
 FunctionComponent<Modal_creation_view_unitary_from_dataType>

export const sankeyDevDialogs = (
  applicationContext : suiteApplicationContextType,
  dict_variable_application_data : suiteApplicationDataType,
  processFunctions : processFunctionsType,
  applicationDraw : applicationDrawType,
  convert_data:ConvertDataFuncType,
  callback:(sankey_data: SankeyDevData) => void,
  dict_hook_ref_setter_show_dialog_components:SankeyDevShowMenuComponentsType
) => {
  const dialogs : JSX.Element[] = []
  dialogs.push(<SankeyDevModalCreationViewUnitaryFromData
    applicationContext={applicationContext}
    dict_variable_application_data={dict_variable_application_data as devApplicationDataType}
    processFunctions={processFunctions}
    applicationDraw={applicationDraw}
    convert_data={convert_data}
    callback={callback as (sankey_data: SankeyData) => void }
    dict_hook_ref_setter_show_dialog_components={dict_hook_ref_setter_show_dialog_components}
  />)
  return dialogs
}